import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, ListGroupItem, TabContent, Nav, NavLink, TabPane, NavItem } from 'reactstrap';

import ClassEditor from './ClassEditor';
import { ImportClassDataModalButton } from './ImportClassDataModal';
import StaffPanel from './StaffPanel';
import StudentPanel from './StudentPanel';
import WithLoader from '../WithLoader';
import authorizedFetch from '../api-authorization/AuthorizedFetch';
import { safeParseResponse } from '../../utils';

const SchoolEditor = () => {
  const { id: schoolId = '' } = useParams();
  
  // todo - correct name for var? "schoolName?"
  // eric: looks that way!
  const [schoolName, setSchoolName] = useState('');
  const [studentClasses, setStudentClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  // todo - do we need this teacherId var? or this staff var? unused
  // eric: it looks like this got pushed down into the StaffPanel component and can be removed from here
  // const [selectedTeacherId, setSelectedTeacherId] = useState(null);
  // const [staff, setStaff] = useState([]);
  const [isNewClass, setIsNewClass] = useState(true);
  const [reloadCount, setReloadCount] = useState(0);
  const [activeTab, setActiveTab] = useState('1');

  const loadSchool = async done => {
    const response = await authorizedFetch(`api/schools/${schoolId}`);
    const school = await safeParseResponse(response) || {};
    setSchoolName(school?.name || '');
    done();
  };

  const loadClasses = async done => {
    const response = await authorizedFetch(`api/schools/${schoolId}/classes`);
    const studentClasses = await safeParseResponse(response) || [];
    setStudentClasses(studentClasses);
    done();
  };

  const getSelectedClass = () => {
    const defaultClass = {
      schoolId,
      name: '',
      teacherEmail: ''
    };
    return studentClasses?.find((c) => c.classId === selectedClassId) ?? defaultClass;
  };

  const addNewClass = () => {
    if(!isNewClass) {
      setSelectedClassId(null);
      setIsNewClass(true);
    }
  };

  const selectStudentClass = selectedClass => {
    if(selectedClassId !== selectedClass?.classId) {
      setSelectedClassId(selectedClass?.classId);
      setIsNewClass(false);
    }
  };
  
  const reloadNow = classId => {
    setSelectedClassId(classId);
    setIsNewClass(false);
    setReloadCount(reloadCount + 1);
  };

  const toggle = tabId => 
    activeTab !== tabId && setActiveTab(tabId);

  return (
    <WithLoader key={reloadCount} action={loadSchool}>
        <h3>School</h3>
        <h5>{schoolName}</h5>
        <ImportClassDataModalButton schoolId={schoolId}>Import Class Data</ImportClassDataModalButton>
        <Nav tabs>
          <NavItem><NavLink active={activeTab === '1'} onClick={() => toggle('1') }>Staff</NavLink></NavItem>
          <NavItem><NavLink active={activeTab === '2'} onClick={() => toggle('2') }>Classes</NavLink></NavItem>
          <NavItem><NavLink active={activeTab === '3'} onClick={() => toggle('3') }>Students</NavLink></NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <StaffPanel schoolId={schoolId} />
          </TabPane>
          <TabPane tabId="2">
            <WithLoader key={reloadCount} action={loadClasses}>
              <Row>
                <Col sm={4}>
                  <ListGroup>
                    <ListGroupItem action active={isNewClass} onClick={addNewClass}>
                        + New
                    </ListGroupItem>

                    {studentClasses.map(studentClass => {
                      const { name: nameOfClass, classId } = studentClass;
                      return (
                        <ListGroupItem 
                          action 
                          active={selectedClassId === classId} 
                          onClick={() => selectStudentClass(studentClass)}
                        >
                          {nameOfClass}
                        </ListGroupItem>
                      );
                    })}
                  </ListGroup>
                </Col>
                <Col>
                  <ClassEditor 
                    schoolId={schoolId} 
                    value={getSelectedClass()} 
                    isNew={isNewClass} 
                    onSaved={reloadNow}
                  />
                </Col>
              </Row>
            </WithLoader>
          </TabPane>
          <TabPane tabId="3">
            <StudentPanel schoolId={schoolId} />
          </TabPane>
        </TabContent>
    </WithLoader>
  );
}

export default SchoolEditor;